import React from 'react'
import { Typography } from '@mui/material'
import { BODY_SKELETON_TEST_ID } from './constants'
import { BodySkeleton, TableCell } from './styles'
import type { TableBodyCellProps } from './types'

const TableBodyCell: React.FC<TableBodyCellProps> = ({ text, isLoading, hideCell }) => {
  if (hideCell) return null

  if (isLoading) {
    return (
      <TableCell omitBorder>
        <BodySkeleton data-testid={BODY_SKELETON_TEST_ID} />
      </TableCell>
    )
  }

  return (
    <TableCell omitBorder>
      <Typography variant="body2">{text}</Typography>
    </TableCell>
  )
}

export default TableBodyCell
